<div class="port-agent-form-container">
    <div class="top-section">
        <span>{{pdaEditData?.disbursement_id}} - {{pdaEditData?.towage}}</span>
        <div class="service-button-section">
            <div class="currency-marquee"
                *ngIf="portAgentForm.get('pda_currency_from')?.value && portAgentForm.get('pda_currency_to')?.value && portAgentForm.get('pda_roe')?.value">
                <span class="marquee-text">
                    Note: 1 {{ portAgentForm.get('pda_currency_from')?.value }} ~=
                    {{ portAgentForm.get('pda_roe')?.value }}
                    {{ portAgentForm.get('pda_currency_to')?.value }}
                    <ng-container *ngIf="shouldShowConvertedCurrencyMarquee()">
                        , 1 {{ portAgentForm.get('converted_curr_from')?.value }} ~=
                        {{ portAgentForm.get('conversion_pda_rate')?.value }}
                        {{ portAgentForm.get('converted_curr_to')?.value }}
                    </ng-container>
                </span>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
                <button type="button" (click)="refreshTariffRules()" class="text-icon refresh-tariff-btn"
                    style="height: 30px;  margin-top: -8px;"
                    [disabled]=" pdaEditData?.towage=== true "
                    [ngClass]="{'disabled-input':  pdaEditData?.towage=== true }">
                    Refresh Rules<mat-icon
                        style="margin-left: 4px; padding-top: 6px; font-size: 18px;">refresh</mat-icon>
                </button>

                <button *ngIf="pdaStatus === 5|| pdaStatus ===6" type="button" (click)="resendPdaRequest()"
                    class="text-icon" style="height: 30px;  margin-top: -8px;" class="text-icon">
                    Resend Link</button>


                <div style=" margin-top: -8px;">
                    <mat-slide-toggle [formControl]="pda_custom_calculation" class="small-toggle"
                        [disabled]="disableTableInputFields"
                        [ngClass]="{'disabled-input': disableTableInputFields}"></mat-slide-toggle>
                    <span style="font-size: 15px; font-weight: 500; width: 120px;">
                        {{ pda_custom_calculation.value ? "User Defined" : "System Defined" }}
                    </span>
                </div>
            </div>
            <button type="button" (click)="recalculateData()" class="text-icon" style="height: 30px"
                [ngClass]="{'disabled-input':  pdaEditData?.towage=== true }"
                [disabled]=" pdaEditData?.towage=== true ">
                Calculate<mat-icon>calculate</mat-icon></button>
            <button type="button" class="text-icon" style="height: 30px" (click)="downloadReport()"
                [disabled]="pdaEditData?.towage=== true"
                [ngClass]="{'disabled-input': pdaEditData?.towage=== true}">
                PDA Report <mat-icon>download</mat-icon>
            </button>
        </div>
    </div>
</div>
<div class="scrollable-section" [ngClass]="{ 'theme-dark': isDarkMode() }">
    <form [formGroup]="portAgentForm" (ngSubmit)="onPdaSubmit('')">
        <div class="field-section">
            <div class="field-grid">
                <div *ngFor="let field of fields; let i = index">
                    <!-- Select field -->
                    <mat-form-field *ngIf="field.type === 'select' && field.value && portAgentForm.get(field.value)"
                        appearance="outline" class="mat-field-small">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [formControlName]="field.value" placeholder="Please select"
                            [matAutocomplete]="auto" (click)="trigger.openPanel()" #trigger="matAutocompleteTrigger"
                            (blur)="onRemove(field)" />

                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect(field.name, $event.option)"
                            [displayWith]="displayFn.bind(this, field)">
                            <mat-option *ngFor="let opt of getFilteredOptions(field)"
                                [value]="getOptionValue(field, opt, addedFields)">
                                {{ field.name === 'Cargo' ? opt?.type : (field.name === 'ToCurrency' || field.name
                                ===
                                'FromCurrency') ? opt : opt?.name }}
                            </mat-option>
                        </mat-autocomplete>

                        <!-- Error handling -->
                        <mat-error *ngIf="portAgentForm.get(field.value)?.hasError('required')">
                            Please select the {{ field.name }}.
                        </mat-error>
                    </mat-form-field>


                    <mat-form-field appearance="outline"
                        *ngIf="field.type === 'date' && field.value && portAgentForm.get(field.value)">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [matDatepicker]="picker" [formControlName]="field.value"
                            (dateChange)="onDateChange()" />
                        <mat-datepicker-toggle matIconSuffix [for]="picker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="portAgentForm.get(field.value)?.hasError('required')">
                            please select the {{ field.name }}
                        </mat-error>

                    </mat-form-field>

                    <mat-form-field
                        [ngClass]="{ 'changed-field': modifiedFields[field.value] && !isExcluded(field.value) }"
                        *ngIf="field.type !== 'date' && field.type !== 'select' && field.value && portAgentForm.get(field.value)"
                        appearance="outline">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [type]="field.data_type || 'text'" [formControlName]="field.value"
                            [readonly]="isFieldReadonly(field)"
                            (blur)=" field.name === 'Vessel Stay'? validateVesselStay(field , portAgentForm) :null  " />

                        <mat-error *ngIf="portAgentForm.get(field.value)?.hasError('required')">
                            {{ field.name }} is required
                        </mat-error>
                        <mat-error
                            *ngIf=" field.name === 'Vessel Stay'&& portAgentForm.get(field.value)?.hasError('invalidFormat')">
                            valid format (e.g., 1D, 1H, 1D 1H,). </mat-error>
                        <mat-error
                            *ngIf="field.name === 'Invoice Ref No' && portAgentForm.get(field.value)?.hasError('invalidData')">
                            Enter Valid Format
                        </mat-error>



                        <!-- 🚩 Flag only if modified and not excluded -->
                        <span mat-icon-button *ngIf="modifiedFields[field.value] && !isExcluded(field.value)" matSuffix
                            disabled class="flag-indicator">
                            🚩
                        </span>
                    </mat-form-field>
                </div>
            </div>

        </div>

        <div class="converted-currency-section" *ngIf="username === 'Meraki - Operations'">
            <mat-form-field appearance="outline">
                <mat-label>Converted Currency From</mat-label>
                <input matInput [matAutocomplete]="fromCurrencyAutocomplete" formControlName="converted_curr_from">
                <mat-autocomplete #fromCurrencyAutocomplete="matAutocomplete">
                    <mat-option *ngFor="let currency of ConvertedFromCurrencyList" [value]="currency">
                        {{ currency }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>


            <mat-form-field appearance="outline">
                <mat-label>Converted Currency To</mat-label>
                <input matInput [matAutocomplete]="portAgentAutocomplete" formControlName="converted_curr_to">
                <mat-autocomplete #portAgentAutocomplete="matAutocomplete"
                    (optionSelected)="onSelect('Converted Currency To', $event.option)">
                    <mat-option *ngFor="let currency of filteredConvertedToCurrency | async" [value]="currency"> {{
                        currency }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Conversion Pda Rate</mat-label>
                <input matInput formControlName="conversion_pda_rate" type="number" />

            </mat-form-field>

        </div>
        <!-- </div> -->
        <!-- Common Table Header for All Sections -->
        <div class="common-table-header" *ngIf="datasource.data && datasource.data.length > 0">
            <div class="table-header">
                <div *ngFor="let column of displayedColumns">
                    <h6>{{ column }}</h6>
                </div>
            </div>
        </div>

        <ng-container *ngFor="let service of datasource.data; let i = index">
            <div class="table-outer" *ngIf="!service.get('isSubService')?.value">
                <div class="table-section">
                    <div class="table-inner">
                        <div class="table-content" [formGroup]="service">
                            <div style="display: flex; gap: 0;">
                                <div>
                                    <h6>{{ getMainServiceIndex(i, datasource.data) }}</h6>
                                </div>
                                <div style="display: flex; align-items: center; gap: 5px;">
                                    <input *ngIf="service.get('isNew')?.value" matInput type="text"
                                        [formControl]="service.get('service')" placeholder="Enter service name"
                                        style="width: 100%; padding: 5px; border: 1px solid #ccc; border-radius: 4px; font-size: 13px;::placeholder{font-size:12px;}" />
                                    <h6 *ngIf="!service.get('isNew')?.value">{{ service.get('service')?.value }}
                                    </h6>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 10px;">
                                    <div style="display: flex; flex-direction: row;  gap: 5px;">
                                        <span
                                            style="font-size: 10px;font-weight: 500; line-height: 2.4; ">IN({{fromCurrency}})</span>
                                        <input matInput type="number"
                                            [formControl]="service.get(service.get('isSubService')?.value ? 'systemSubTotal' : 'systemTotal')"
                                            (input)="calculateMerakiServicegrandTotal()" readonly />
                                    </div>
                                    <div style="display: flex; flex-direction: row;  gap: 5px;">
                                        <span
                                            style="font-size: 10px;font-weight: 500;line-height: 2.4; ">IN({{toCurrency}})</span>

                                        <input matInput type="number"
                                            [value]="calculateSystemAndAgentValueWithRoe(service, 'system', 'ToCurrency')"
                                            readonly />
                                    </div>
                                    <div style="display: flex; flex-direction: row;  gap: 5px;">
                                        <span *ngIf="displayConvertedToCurrency"
                                            style="font-size: 10px;font-weight: 500;line-height: 2.4; ">IN({{convertedToCurrencyValue}})</span>

                                        <input matInput type="number" *ngIf="displayConvertedToCurrency"
                                            [value]="calculateSystemAndAgentValueWithRoe(service, 'system', 'convertedToCurrency')"
                                            readonly />
                                    </div>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 10px;">
                                    <!-- <div style="display: flex; flex-direction: row; gap: 5px;"> -->
                                    <input matInput type="number"
                                        [formControl]="service.get(service.get('isSubService')?.value ? 'sub_total' : 'total')"
                                        (input)="calculateAgentServiceGrandTotal()"
                                        [readonly]="portAgentForm.get('towage')?.value === true"
                                        (keydown)="restrictDecimal($event, 2)" (blur)="onTotalBlur(service, null)"
                                        (focus)="onTotalFocus(service, null)" />
                                    <!-- </div> -->
                                    <input matInput type="number"
                                    (input)="onSecondaryAgentValueChange(service, $event)"
                                        [value]="calculateSystemAndAgentValueWithRoe(service, 'agent', 'ToCurrency')"
                                         />

                                    <input matInput type="number" *ngIf="displayConvertedToCurrency"
                                        [value]="calculateSystemAndAgentValueWithRoe(service, 'agent', 'convertedToCurrency')"
                                         />
                                </div>
                                <span *ngIf="shouldShowFlag(service)">🚩</span>

                                <div *ngIf="displayAgreedAndNegotiateColumn"
                                    style="display: flex; align-items: center; justify-content: left; margin-left: -10px;">
                                    <mat-slide-toggle [checked]="service.get('negotiate')?.value === 'Y'"
                                        (change)="onAgreedNegotiateToggle(service, $event.checked)" color="primary"
                                        style="transform: scale(0.5);"
                                        [ngClass]="service.get('negotiate')?.value === 'Y' ? 'toggle-negotiate' : 'toggle-agreed'">
                                    </mat-slide-toggle>
                                    <span style="font-size: 14px; font-weight: 500; color: var(--app-text-primary);">
                                        {{ service.get('negotiate')?.value === 'Y' ? 'Negotiate' : 'Agreed' }}
                                    </span>
                                </div>
                                <mat-icon *ngIf="service.get('isNew')?.value" (click)="submitServiceName(service)"
                                    style="margin-left: 20px; cursor: pointer; color: green; font-size: 20px;"
                                    matTooltip="Submit service name">
                                    check
                                </mat-icon>
                                <mat-icon *ngIf="canDeleteSpecificService(service)" (click)="deleteService(service)"
                                    style="margin-left: 10px; color: red; cursor: pointer;" matTooltip="Delete service">
                                    delete
                                </mat-icon>
                            </div>
                            <div>
                                <h6>{{ service.get('info_msg')?.value }}</h6>
                            </div>
                        </div>
                        <div class="service-note-2" [ngClass]="getServiceNoteClass(service)"
                            *ngIf="shouldShowServiceNote(service) && service.get('subService')?.value?.length === 0">
                            <h6>Note:</h6>
                            <p>{{ getServiceNoteMessage(service) }}</p>
                        </div>
                        <div class="table-service" *ngIf="service.get('subService')?.value?.length > 0">
                            <div class="empty-space"></div>
                            <div class="warning-section">
                                <div class="table-checkbox" *ngIf="service.get('subService')?.value.length > 0">
                                    <mat-checkbox
                                        *ngFor="let subService of service.get('subService')?.value; let i = index"
                                        [checked]="!subService.optional"
                                        (click)="onCheckboxClick(service, subService, i)"
                                        [style.display]="subService.hide === 'Y' ? 'none' : 'flex'">
                                        {{ subService.name || service.get('service')?.value }}
                                    </mat-checkbox>
                                </div>
                                <div class="movement-section">
                                    <div class="movement-inputs"
                                        *ngIf="service.get('subService')?.controls?.length > 0">
                                        <div class="movement-item"
                                            *ngFor="let subServiceControl of service.get('subService')?.controls; let j = index"
                                            [formGroup]="subServiceControl"
                                            [style.display]="service.get('subService')?.value[j]?.hide === 'Y' ? 'none' : 'block'">
                                            <textarea rows="2"
                                                [formControl]="subServiceControl.get('formattedSystemMovement')"
                                                class="movement-textarea" appAutoResizeInput [minWidth]="150"
                                                [maxWidth]="280" [bufferSpace]="30"
                                                style="color: var(--app-input-text) !important; -webkit-text-fill-color: var(--app-input-text) !important">
                                                </textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="service-note" [ngClass]="getServiceNoteClass(service)"
                                    *ngIf="shouldShowServiceNote(service) ">
                                    <h6>Note:</h6>
                                    <p>{{ getServiceNoteMessage(service) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-textarea" [formGroup]="service">
                        <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" readonly class="textarea-1"
                            placeholder="Port Agent Remark" rows="2" formControlName="pa_remark"></textarea>
                        <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" class="textarea-2"
                            placeholder="Meraki Feedback" rows="2" formControlName="meraki_feedback"></textarea>
                        <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" readonly class="textarea-3"
                            placeholder="Client Comment" rows="2" formControlName="formated_client_comment"></textarea>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="total-section" *ngIf="datasource.data && datasource.data.length > 0">
            <div class="total-item">
                <label style="color: var(--app-text-primary);">System Total:</label>
                <div style="display: flex; flex-direction:column;gap: 10px;">
                    <div style="display: flex; gap: 10px;">
                        <span class="currency-text">IN({{fromCurrency}})</span> <input type="number"
                            [value]="getSystemGrandTotal()" readonly />
                    </div>
                    <div style="display: flex; gap: 10px;">
                        <span class="currency-text">IN({{ toCurrency}})</span> <input type="number"
                            [value]="getSystemAndAgentTotal('system', 'ToCurrency')" readonly />
                    </div>
                    <div style="display: flex; gap: 10px;">
                        <span class="currency-text" *ngIf="displayConvertedToCurrency">IN({{
                            convertedToCurrency}})</span> <input type="number"
                            [value]="getSystemAndAgentTotal('system', 'convertedToCurrency')"
                            *ngIf="displayConvertedToCurrency" readonly />
                    </div>
                </div>


            </div>
            <div class="total-item">
                <label style="color: var(--app-text-primary);">Agent Value Total:</label>
                <div style="display: flex; flex-direction:column;gap: 10px;">
                    <div style="display: flex; gap: 10px;">
                        <span class="currency-text">IN({{fromCurrency}})</span> <input type="number"
                            [value]="agentServiceGrandTotal != null ? agentServiceGrandTotal.toFixed(2) : null"
                            readonly />
                    </div>
                    <div style="display: flex; gap: 10px;">
                        <span class="currency-text">IN({{ toCurrency}})</span> <input type="number"
                            [value]="getSystemAndAgentTotal('agent', 'ToCurrency')" readonly />
                    </div>
                    <div style="display: flex; gap: 10px;">
                        <span class="currency-text" *ngIf="displayConvertedToCurrency">IN({{
                            convertedToCurrency}})</span> <input type="number" *ngIf="displayConvertedToCurrency"
                            [value]="getSystemAndAgentTotal('agent', 'convertedToCurrency')" readonly />
                    </div>
                </div>
            </div>
        </div>

        <!-- </div> -->
        <div class="footer-section" *ngIf="username === 'Meraki - Operations'">
            <mat-form-field appearance="outline">
                <mat-label>Payment Currency From</mat-label>
                <input matInput [matAutocomplete]="paymentAutocomplete" formControlName="pmt_curr_from">
                <mat-autocomplete #paymentAutocomplete="matAutocomplete"
                    (optionSelected)="onSelect('Payment Currency From', $event.option)">
                    <mat-option *ngFor="let currency of PaymentFromCurrencyList" [value]="currency">
                        {{ currency }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>


            <mat-form-field appearance="outline">
                <mat-label>Payment Currency To</mat-label>
                <input matInput [matAutocomplete]="portAgentAutocompletebelowSection" formControlName="pmt_curr_to">
                <mat-autocomplete #portAgentAutocompletebelowSection="matAutocomplete">
                    <mat-option *ngFor="let currency of filteredPaymentToCurrency | async" [value]="currency">
                        {{ currency }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Payment Currency Rate</mat-label>
                <input matInput formControlName="conversion_rate" type="number"
                    (input)=" calculatePercentage('Conversion Rate')" />
                <mat-error *ngIf="portAgentForm.get('conversion_rate')?.hasError('required')">
                    Conversion Rate is required
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label> Currency Conversion</mat-label>
                <input readonly matInput formControlName="currency_conversion" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Advance Percentage</mat-label>
                <input matInput formControlName="advance_percentage" type="number"
                    (input)=" calculatePercentage('Advance Percentage')" />
                <mat-error *ngIf="portAgentForm.get('advance_percentage')?.hasError('required')">
                    Advance percentage is required
                </mat-error>
                <mat-error *ngIf="portAgentForm.get('advance_percentage')?.hasError('max')">
                    Advance percentage cannot exceed 100
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>PDA Remittance</mat-label>
                <input readonly matInput formControlName="Pda_remittance" />
            </mat-form-field>

        </div>
        <div style="display: flex; flex-direction: row; justify-content: flex-end; gap: 10px; margin: 10px 20px;">
            <div class="currency-conversion-mismatch-banner" *ngIf="showCurrencyConversionMismatchBanner">
                <span class="banner-text"> Currency Conversion Mismatch: Calculated value
                    ({{calculatedCurrencyConversion | number:'1.2-2'}}) Entered
                    ({{responseCurrencyConversion | number:'1.2-2'}})</span>
            </div>
            <div class="remittance-mismatch-note" *ngIf="showRemittanceMismatchNote">
                <span class="note-text">Note: Remittance mismatch detected (Calculated: {{calculatedRemittance |
                    number:'1.2-2'}}, Entered: {{pdaRemittanceFromResponse}})</span>
                <mat-icon class="refresh-icon" *ngIf="pdaStatus !== 7" (click)="refreshRemittance()"
                    matTooltip="Set calculated Remittance">refresh</mat-icon>
            </div>
        </div>
    </form>

    <app-comm-history [data]="communicationHistory"></app-comm-history>


    <div class="button-section">
        <button class="text-icon" [disabled]="disableTableInputFields "
            [ngClass]="{'disabled-input': disableTableInputFields }" style="height: 30px"
            (click)="upload()">Upload
            File <mat-icon>cloud_upload</mat-icon></button>

        <button class="warning-action-btn" [disabled]="disableTableInputFields "
            *ngIf="isNegotiateSelected && (pdaStatus === 3 || pdaStatus === 4 || pdaStatus === 9)"
            (click)="pdaEditSubmitAndSave('Request Approval')">
            Request Approval</button>
        <button (click)="openCreateServiceDialog()" [disabled]="disableTableInputFields "
            [ngClass]="{'disabled-input': disableTableInputFields }">Add Service</button>
        <button class="warning-action-btn" [disabled]="disableTableInputFields "
            *ngIf="(isNegotiateSelected &&(pdaStatus === 3 ||pdaStatus === 4 || pdaStatus === 9)) || portAgentReturnStatus === 'Y'"
            [ngClass]="{'disabled-input': disableTableInputFields }"
            (click)="pdaEditSubmitAndSave('Re Request')">Re
            Request</button>
        <button (click)="onSave('save')" [disabled]="disableTableInputFields "
            [ngClass]="{'disabled-input': disableTableInputFields }">Save</button>
        <button (click)="onPdaSubmit('Submit')" [disabled]="disableTableInputFields "
            *ngIf="!isNegotiateSelected || isManualCreation === 'Y'"
            [ngClass]="{'disabled-input': disableTableInputFields }">Submit</button>
    </div>
</div>